<template>
  <div class="home">
    <div :class="MAIN_CLASS">
      <div style="overflow: hidden;">
        <div class="main_l">
        <!-- 我的作业 -->
        <div class="my_work clearfix">
          <!-- <img v-if="URL_MAQIN == 2" src="../assets/kjc我的作业.png" alt />
          <img v-if="URL_MAQIN == 1" src="../assets/img/studyCard.png" alt /> -->
          <div class="name">
            <button @click.stop="goStudyCard">
              <img src="../assets/img/studyCard.png" alt />
              添加学习卡
            </button>
            <span v-show="work_status == 1"></span>
          </div>
          <!-- <div class="icon">
            <i class="el-icon-arrow-right"></i>
          </div> -->
        </div>
        <div class="calendar">
          <inlineCalendar
            @change="onChange"
            :monthNames="monthNames"
            :weekNames="week"
          >
            <template v-slot:day="scope">
              <div class="box" v-for="(item, index) in days" :key="index">
                <div
                  v-if="scope.date.dateTime.format('YYYY-MM-DD') == item"
                  class="point"
                ></div>
              </div>
            </template>
          </inlineCalendar>
        </div>
        <!-- 课程 -->
        <div class="course" v-if="class_list_left1.length != 0">
          <div
            class="course_item"
            v-for="(item, index) in class_list_left"
            :key="index"
            @click="live_click(item)"
          >
            <div class="tag">{{ item.type_plan }}</div>
            <div class="title">{{ item.course_title }}</div>
            <div class="title">{{ item.subject_title }}</div>

            <div class="course_min_name">{{ item.chapter_title }}</div>
            <div class="course_bottom clearfix">
              <img v-if="URL_MAQIN == 2" src="../assets/kjc闹钟.png" alt />
              <img v-if="URL_MAQIN == 1" src="../assets/闹钟.png" alt />
              <div class="time">{{ item.live_time }}</div>
              <div class="alt">{{ item.live_time_plan }}</div>
            </div>
          </div>
        </div>
        </div>
        <div class="main_r">
          <div class="nullBox" v-if="class_list.length == 0">
            <img src="@/assets/img/nullBox.png" alt="" />
            <p>你暂时未报名任何课程</p>
            <button @click="return_shop">去商城看看</button>
          </div>
          <!-- 右边顶部导航 -->
          <div class="topNav" v-if="class_list.length > 0">
            <ul>
              <li
                v-for="(item, index) in class_list"
                :key="index"
                @click="navChecked(item.id)"
                :class="[navNum == item.id ? 'topNavActive' : '']"
              >
                {{ item.name }}
              </li>
              <div class="expire_entrance" @click="$router.push('/class_expire')">
              <img src="@/assets/img/guoqi.png" alt="">
                过期课程
              </div>
            </ul>
          </div>
          <!-- 右边课程 -->
          <!-- <div
            class="keep_class clearfix"
            v-show="Previous_class.chapter_id"
            @click="keep_cilck(Previous_class)"
          >
            <span>上次学到 {{ Previous_class.title }}</span>
            <img v-if="URL_MAQIN == 2" src="../assets/kjc播放.png" alt />
            <img v-if="URL_MAQIN == 1" src="../assets/播放.png" alt />
          </div> -->
          <div
            class="class"
            v-for="(item, index) in curr_class_list"
            :key="index"
            v-if="item.is_over_time===0"
          >
            <div class="class_title clearfix">
              <img v-if="URL_MAQIN == 2" src="../assets/kjc课程.png" alt />
              <img v-if="URL_MAQIN == 1" src="../assets/课程.png" alt />
              <span>{{ item.title }}</span>
            </div>

            <div class="class_list" v-if="item.subject">
              <div class="class_list_title clearfix">
                <span style="width: 250px">科目名称</span>
                <span style="width: 422px"></span>
                <span style="width: 200px">相关操作</span>
              </div>
              <div
                class="class_list_tr clearfix"
                v-for="(item1, index) in item.subject"
                :key="index"
              >
                <span style="width: 250px">{{ item1.title }}</span>
                <span style="width: 422px"></span>
                <span style="width: 200px">
                  <div class="btn" @click="study_click(item, item1.chapter_id, item1.title)">
                    {{ item1.is_learn == 0 ? "开始学习" : "继续学习" }}
                  </div>
                  <div class="btn" style="margin-top: 5px;background: #ffffff;border: 1px solid #FADA1E;" @click="goShicao()" v-if="has_shicao==1">
                      实操练习
                  </div>
                </span>
              </div>
            </div>
            <div class="class_list" v-else>
              <div class="class_list_title clearfix">
                <span style="width: 250px">科目名称</span>
                <span style="width: 422px"></span>
                <span style="width: 200px">相关操作</span>
              </div>
              <div class="class_list_tr clearfix">
                <span style="width: 250px">{{ item.title }}</span>
                <span style="width: 422px"></span>
                <span style="width: 200px">
                  <div class="btn" @click="one_study_click(item)">
                    {{ item.is_learn == 0 ? "开始学习" : "继续学习" }}
                  </div>
                  <div class="btn" style="margin-top: 5px;background: #ffffff;border: 1px solid #FADA1E;" @click="goShicao()" v-if="has_shicao==1">
                      实操练习
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div class="class" v-else>
            <div class="class_title clearfix">
              <img v-if="URL_MAQIN == 2" src="../assets/kjc课程.png" alt />
              <img v-if="URL_MAQIN == 1" src="../assets/课程.png" alt />
              <span>{{ item.title }}</span>
            </div>
            <div class="class_list">
              <div
                class="class_list_tr clearfix"
              >
                <span style="width: 250px">课程已经过期</span>
                <span style="width: 422px"></span>
                <span style="width: 200px">
                  <div
                    class="btn"
                    style="width:120px"
                    @click="yiru(item)"
                  >
                    移入往期课程
                  </div>
                </span>
              </div>
            </div>
          </div>

          <!-- 猜你喜欢 -->
          <!-- <div class="you_like" v-if="like_class.length > 0">
            <div class="you_like_title"><span></span>猜你喜欢</div>
            <div class="you_like_content clearfix">
              <div
                class="you_like_item clearfix"
                v-for="(item, index) in like_class"
                :key="index"
                @click="sign_click(item.buy_url)"
              >
                <div class="you_like_item_l">
                  <div class="name">{{ item.title }}</div>
                  <div class="time">
                    {{ item.course_start_time }}
                    <span v-if="item.courser_chapter_count"
                      >{{ item.courser_chapter_count }}课时</span
                    >
                  </div>
                </div>
                <div class="you_like_item_r">
                  <img :src="item.thumb_url" alt />
                </div>
                <div class="you_like_item_b">
                  <div class="teacher clearfix">
                    <div
                      class="teacher_item"
                      v-for="(item1, index) in item.teacher"
                      :key="index"
                    >
                      <img :src="item1.head_ico" alt />
                      <span>{{ item1.name }}</span>
                    </div>
                  </div>
                  <div class="price clearfix">
                    <div class="over">已售2444人</div>
                    <div class="after">原价999元</div>
                    <div class="btn">3人拼 0元</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- v3猜你喜欢 -->
          <div class="recommend" v-if="like_class.length > 0">
            <div class="titleBox">猜你喜欢</div>
            <div class="content gundong">
              <a v-for="(item,index) in like_class" :key="index" :href="item.buy_url" class="card">
                <a :href="config.ShoppUrl+'/site/shicaoMemberGoods'" target="_blank" v-if="item.is_member_free==1">
                  <img src="../assets/img/vipFree.png" alt="" style="height:24px;position:absolute;top:4px;left:12px;">
                </a>

                <div class="title">{{item.title}}</div>
                <div class="iconBox">
                  <div class="icon" v-for="(item2,index2) in item.teacher" :key="index2">
                    <img :src="item2.head_ico" alt="">
                    <span>{{item2.name}}</span>
                  </div>
                </div>
                <div class="bottomBox">
                    <!-- 价格判断 -->
                    <div class="price" v-if="item.bargain_info&&item.bargain_info.base_price">
                      砍价¥{{item.bargain_info.base_price}}
                    </div>
                    <div class="price" v-else-if="item.collage_info&&item.collage_info.spell_price">
                      拼团价¥{{item.collage_info.spell_price}}
                    </div>
                    <div class="price" v-else-if="item.ticket&&item.ticket.ticket_price">
                      券后价¥{{item.ticket.ticket_price}}
                    </div>
                    <div class="price" v-else>
                      {{item.sell_price===0?'免费':'¥'+item.sell_price}}
                    </div>


                    <div class="tip">已售{{item.sale}}人</div>
                    <button>立即购买</button>
                  </div>
              </a>
            </div>
          </div>



        </div>
      </div>


      <div class="nextPlay" v-show="Previous_class.chapter_id&&isShowNext">
        <img src="../assets/img/close.png" alt="" class="close" @click.stop="delPreviousM()">
        <div class="content">
          <div class="title">
            <img src="../assets/img/classIcon.png" alt="">
            {{Previous_class.course_name}}
          </div>
          <div class="more">{{Previous_class.title}}</div>
        </div>
        <button @click="keep_cilck(Previous_class)"><img src="../assets/img/play.png" alt="">继续播放</button>
      </div>

    </div>

    

    <div class="adBox" v-if="adData.length > 0 && showAd">
      <a :href="adData[0].link" target="_blank">
        <img :src="adData[0].content" />
      </a>
        <div class="closeBox" @click="showAd=false">
          <img src="../assets/img/activity_off.png" alt=""/>
        </div>
    </div>
  </div>
</template>
<script>
import {
  Course,
  Guess,
  Notice,
  Previous,
  WorkStatus,
  Schedule,
  billing,
  delPrevious,
  updateCourseExpireTimeStatus,
  HasShicao
} from "@/api/index";
import appConfig from "@/api/appConfig";
export default {
  data() {
    return {
      showAd: true,
      navNum: 0,
      attrs: [
        {
          key: "today",
          dot: true,
          dates: new Date(),
        },
      ],
      days: [],
      monthNames: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      week: ["一", "二", "三", "四", "五", "六", "日"],
      class_list: [], //所有课程
      curr_class_list: [], //当前选择的课程
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      like_class: [], //猜你喜欢
      notice_class: [], //直播预告
      Previous_class: {}, //上次播放记录,
      work_status: 0, //作业状态
      class_list_left: [], //课程表
      class_list_left1: [], //备用课程表
      adData: [],
      isShowNext:true,
      config:appConfig,
      has_shicao:0
    };
  },
  mounted() {
    this.getBilling();
    if (this.URL_MAQIN == 2) {
      let obj = {};
      obj.platform = 2;
      this.guess(obj);
    } else if (this.URL_MAQIN == 1) {
      let obj = {};
      obj.platform = 1;
      this.guess(obj);
    }
    this.course();
    this.previous();
    this.workStatus();
    this.schedule();
    this.hasShicao();
  },
  methods: {
    // 移入往期课程
    yiru(item){
      this.$confirm('该课程已过期，不能继续学习，如需继续学习，请联系客服优惠开通', '提示', {
          confirmButtonText: '移入往期课程',
          cancelButtonText: '返回学堂',
          type: 'warning'
        }).then(() => {
          updateCourseExpireTimeStatus({course_id:item.course_id}).then(async res=>{
            await this.course()
            this.$toast(res.msg||'已移入，可前往【我的】-【往期课程】查看')
          })
        }).catch(() => {
                   
        });
    },
    // 关闭继续播放
    delPreviousM(){
      this.isShowNext=false
      delPrevious().then(res=>{})
    },
    // 广告
    getBilling() {
      billing(25, 0).then((res) => {
        this.adData = res;
      });
    },
    return_shop() {
      let url = appConfig.ShoppUrl;
      window.location.href = url;
    },
    course() {
      Course().then((res) => {
        this.class_list=[]
        let data = res;
        console.log(res);
        if (data.length == 0) return;
        for (let item of data) {
          if (item.course_list.length != 0) this.class_list.push(item);
        }
        console.log(this.class_list);
        this.curr_class_list = this.class_list[0].course_list;
        this.navNum = this.class_list[0].id;
        // for (let i = 0; i < this.class_list.length; i++) {
        //   if (this.class_list[i].type == 8) {
        //     this.class_list.splice(i, 1);
        //   }
        // }
      });
    },
    guess(obj) {
      Guess(obj).then((res) => {
        this.like_class = res;
      });
    },
    notice() {
      Notice().then((res) => {
        this.notice_class = res;
      });
    },
    previous() {
      Previous().then((res) => {
        this.Previous_class = res;
      });
    },
    workStatus() {
      WorkStatus().then((res) => {
        this.work_status = res.work_status;
      });
    },
    schedule() {
      Schedule().then((res) => {
        console.log(res);
        // this.class_list_left = res;
        this.class_list_left1 = res;
        let newDate = this.dateTime(new Date());
        let class_list_left = [];
        for (let i = 0; i < res.length; i++) {
          this.days.push(res[i].live_date);
          if (res[i].live_date == newDate) {
            class_list_left.push(res[i]);
          }
        }
        this.class_list_left = class_list_left;
      });
    },
    dateTime(date) {
      var year = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      return year + "-" + m + "-" + d;
    },
    // 点击学习
    study_click(item, chapter_id, title) {
      if (item.type == 3) {
        sessionStorage.setItem("course_id", item.course_id);
        sessionStorage.setItem("chapter_id", chapter_id);
        this.$router.push({
          path: "question_bank",
          query: {
            course_id: item.course_id,
            chapter_id: chapter_id,
            name: title,
            type: item.type,
          },
        });
      } else if (item.type == 9) {
        this.$router.push({
          path: "handouts",
          query: {
            course_id: item.course_id,
            chapter_id: chapter_id,
          },
        });
      }else if(item.type == 10){
        this.$router.push({
          path: "superClass",
          query: {
            course_id: item.course_id,
            chapter_id: chapter_id
          }
        });
      } else {
        sessionStorage.setItem("course_id", item.course_id);
        sessionStorage.setItem("chapter_id", chapter_id);
        this.$router.push({
          name: "visit_class",
          query: { course_id: item.course_id, chapter_id: chapter_id },
        });
      }
    },
    // 单课程
    one_study_click(item) {
      sessionStorage.clear();
      sessionStorage.setItem("course_id", item.course_id);
      sessionStorage.setItem("chapter_id", 0);
      if (!item.chapter_id) item.chapter_id = 0;
      if (item.type == 9) {
        this.$router.push({
          path: "handouts",
          query: {
            course_id: item.course_id,
            chapter_id: item.chapter_id,
          },
        });
      } else {
        this.$router.push({
          name: "visit_class",
          query: { course_id: item.course_id },
        });
      }
    },
    work_click() {
      this.$router.push({ name: "my_works" });
    },
    // 继续播放
    keep_cilck(item) {
      if (item.video_type == 2) {
        sessionStorage.setItem("id", item.chapter_id);
        const { href } = this.$router.resolve({
          path: "playback",
          query: {
            id: 1,
            course_id: item.course_id,
          },
        });
        window.open(href, "_blank");
      } else if (item.video_type == 9) {
        let vhallUrll =
          appConfig.classUrl +
          "/play/" +
          item.chapter_id +
          "/" +
          "course_id/" +
          item.course_id +
          ".html";
        window.open(vhallUrll, "_blank");
      } else if (item.video_type == 11) {
        let ccUrl =
          appConfig.classUrl +
          "/bokecc/" +
          item.chapter_id +
          "/" +
          item.course_id +
          ".html";
        window.open(ccUrl, "_blank");
      }
    },
    sign_click(url) {
      // window.location.href = url;

      window.open(url, "_blank");
    },
    onChange(date) {
      let chaunge_date = date.format("YYYY-MM-DD");
      console.log(chaunge_date);
      let arr = [];
      for (let i = 0; i < this.class_list_left1.length; i++) {
        if (this.class_list_left1[i].live_date == chaunge_date) {
          arr.push(this.class_list_left1[i]);
        }
      }
      this.class_list_left = arr;
    },
    live_click(item) {
      if (item.is_lock == 1) {
        let ccUrl =
          appConfig.classUrl +
          "/bokecc/" +
          item.chapter_id +
          "/" +
          item.course_id +
          ".html";
        // window.location.href = ccUrl;

        window.open(ccUrl, "_blank");
      } else {
        return;
      }
    },
    navChecked(num) {
      //0全部1考证2实操3免费4最近
      console.log(num);
      this.navNum = num;
      //选中数据处理
      for (let item of this.class_list) {
        if (item.id == num) {
          this.curr_class_list = item.course_list;
        }
      }
    },
    goStudyCard(){
      window.open(`${appConfig.ShoppUrl}/ucenter/card_detail`)
    },
    hasShicao() {
        HasShicao().then((res) => {
            this.has_shicao = res.has_shicao;
        });
    },
    goShicao(){
        window.open(`${appConfig.shicaoUrl}`)
    }
  },
};
</script>
<style lang="scss" scoped>
.main_mfd {
  overflow: hidden;
  margin-bottom: 154px;
  .main_l {
    float: left;
    width: 423px;
    .my_work {
      // cursor: pointer;
      padding: 28px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      margin-bottom: 32px;
      display: flex;
      justify-content: center;
      img {
        float: left;
        width: 44px;
        height: 44px;
      }
      .name {
        position: relative;
        float: left;
        // margin-left: 25px;
        margin-top: 10px;
        font-size: 19px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        button{
          width: 229px;
          height: 57px;
          background: #FADA1E;
          border-radius: 29px;
          font-size: 19px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          border: 0;
          position: relative;
          bottom: 5px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 44px;
            margin-right: 14px;
          }
        }
        span {
          display: block;
          width: 12px;
          height: 12px;
          background: rgba(254, 76, 75, 1);
          border-radius: 50%;
          position: absolute;
          top: -5px;
          right: -5px;
        }
      }
      .icon {
        float: right;
        .el-icon-arrow-right {
          font-size: 28px;
          line-height: 44px;
        }
      }
    }
    .calendar {
      border: 1px solid rgba(238, 238, 238, 1);
    }
    .course {
      padding: 32px 32px;
      background-color: #fff;
      // border-top: 1px solid #eee;
      border: 1px solid rgba(238, 238, 238, 1);
      .course_item {
        cursor: pointer;
        padding: 32px 0 32px 0;
        position: relative;
        border-bottom: 1px solid #eee;
        margin-bottom: 32px;
        .tag {
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          height: 20px;
          background: rgba(250, 220, 30, 1);
          border-radius: 7px 0px 7px 0px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          text-align: center;
          line-height: 20px;
        }
        .title {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          width: 296px;
          margin-bottom: 12px;
        }
        .course_name {
          width: 296px;
          font-size: 18px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 26px;
          margin-bottom: 14px;
        }
        .course_min_name {
          width: 315px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
          margin-bottom: 25px;
        }
        .course_bottom {
          img {
            float: left;
            width: 18px;
            height: 19px;
          }
          .time {
            float: left;
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            margin-left: 22px;
            line-height: 19px;
          }
          .alt {
            float: right;
            font-size: 14px;
            font-weight: 500;
            color: rgba(250, 52, 119, 1);
          }
        }
      }
    }
  }
  .main_r {
    float: right;
    width: 913px;
    .topNav {
      // height: 87px;
      height: 100px;
      width: 100%;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      margin-bottom: 32px;
      ul {
        display: flex;
        align-items: center;
        height: 100%;
        position: relative;
        li {
          font-size: 18px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          margin: 0 32px;
          cursor: pointer;
        }
        .expire_entrance {
          width: 129px;
          height: 35px;
          background: #FADA1E;
          border-radius: 20px;
          text-align: center;
          float: right;
          position: absolute;
          right: 32px;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 28px;
            margin-right: 8px;
          }
        }
      }
    }
    .topNavActive {
      position: relative;
      &:before {
        content: "";
        width: 72px;
        height: 6px;
        background: rgba(250, 220, 30, 1);
        position: absolute;
        bottom: -17px;
      }
    }
    .keep_class {
      cursor: pointer;
      padding: 24px 32px;
      background-color: #fff;
      span {
        float: left;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-right: 10px;
      }
      img {
        float: left;
        width: 23px;
        height: 23px;
      }
    }
    .class {
      background-color: #fff;
      border: 1px solid #eee;
      margin-bottom: 32px;
      .class_title {
        padding: 24px 0 20px 33px;
        border-bottom: 1px soli #eee;
        img {
          width: 32px;
          height: 32px;
          float: left;
        }
        span {
          float: left;
          margin-left: 16px;
          font-size: 20px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
        }
      }

      .class_list {
        .class_list_title {
          padding: 24px 0;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;

          span {
            display: block;
            float: left;
            text-align: center;
            &:last-of-type {
              float: right;
            }
          }
        }
        .class_list_tr {
          padding: 24px 0;
          border-bottom: 1px solid #eee;
          span {
            display: block;
            float: left;
            text-align: center;
            &:last-of-type {
              float: right;
            }
          }
        }
        .btn {
          width: 72px;
          height: 25px;
          background: rgba(250, 220, 30, 1);
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          text-align: center;
          line-height: 25px;
          margin: auto;
          cursor: pointer;
        }
      }
    }
    .you_like {
      background-color: #fff;
      border-bottom: 1px solid #eee;
      .you_like_title {
        padding: 22px 32px;
        border-bottom: 1px solid #eee;
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 30px;
        span {
          float: left;
          display: block;
          width: 8px;
          height: 30px;
          background: rgba(250, 220, 30, 1);
          margin-right: 24px;
        }
      }
      .you_like_content {
        padding: 32px 40px;
        .you_like_item {
          cursor: pointer;
          width: 364px;
          height: 305px;
          background: rgba(255, 255, 255, 1);
          border-radius: 7px;
          border: 2px solid rgba(238, 238, 238, 1);
          padding: 21px 14px 0 14px;
          position: relative;
          float: left;
          margin-right: 32px;
          margin-bottom: 32px;
          &:nth-of-type(2n) {
            margin-right: 0;
          }
          .you_like_item_l {
            float: left;
            width: 220px;

            .name {
              height: 58px;
              font-size: 22px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              margin-bottom: 22px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .time {
              font-size: 14px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              span {
                margin-left: 10px;
                color: #fa6400;
              }
            }
          }
          .you_like_item_r {
            float: right;
            // background: url("../assets/bg.png") center center no-repeat;
            // background-size: cover;
            width: 111px;
            height: 123px;
            text-align: center;
            line-height: 123px;
            font-size: 38px;
            font-weight: 500;
            color: rgba(250, 100, 0, 1);
            img {
              width: 100%;
            }
          }
          .you_like_item_b {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            .teacher {
              padding: 0 14px 23px 14px;
              border-bottom: 2px solid #eee;
              .teacher_item {
                // float: left;
                // line-height: 37px;
                // margin-right: 46px;
                display: flex;
                align-items: center;
                width: 56px;
                justify-content: center;
                text-align: center;
                flex-direction: column;
                float: left;
                margin-right: 17px;
                &:last-of-type {
                  margin-right: 0;
                }
                img {
                  // float: left;
                  width: 37px;
                  height: 37px;
                  border-radius: 50%;
                  // margin-right: 11px;
                }
                span {
                  margin-top: 5px;
                }
              }
            }
            .price {
              padding: 25px 14px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(153, 153, 153, 1);
              line-height: 40px;
              .over {
                float: left;
              }
              .after {
                float: left;
                margin-left: 66px;
              }
              .btn {
                float: right;
                width: 134px;
                height: 40px;
                background: rgba(250, 220, 30, 1);
                border-radius: 22px;
                font-size: 18px;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                text-align: center;
                line-height: 40px;
              }
            }
          }
        }
      }
    }
    .nullBox {
      width: 100%;
      height: 540px;
      text-align: center;
      img {
        width: 226px;
        margin-top: 90px;
      }
      p {
        margin-top: 20px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(191, 155, 159, 1);
      }
      button {
        margin-top: 30px;
        width: 416px;
        height: 76px;
        line-height: 76px;
        background: rgba(250, 220, 30, 1);
        border-radius: 38px;
        border: 0;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
      }
    }
  }
}
.point {
  width: 6px;
  height: 6px;
  background: rgba(254, 76, 75, 1);
  border-radius: 50%;
  position: absolute;
  top: 8px;
  right: 16px;
}
.main_kjc {
  .main_l {
    float: left;
    width: 423px;
    .my_work {
      cursor: pointer;
      padding: 28px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      margin-bottom: 32px;
      img {
        float: left;
        width: 44px;
        height: 44px;
      }
      .name {
        position: relative;
        float: left;
        margin-left: 25px;
        margin-top: 10px;
        font-size: 19px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);

        span {
          display: block;
          width: 12px;
          height: 12px;
          background: rgba(254, 76, 75, 1);
          border-radius: 50%;
          position: absolute;
          top: -5px;
          right: -5px;
        }
      }
      .icon {
        float: right;
        .el-icon-arrow-right {
          font-size: 28px;
          line-height: 44px;
        }
      }
    }
    .calendar {
      border: 1px solid rgba(238, 238, 238, 1);
    }
    .course {
      padding: 32px 32px;
      background-color: #fff;
      // border-top: 1px solid #eee;
      border: 1px solid rgba(238, 238, 238, 1);
      .course_item {
        cursor: pointer;
        padding: 32px 0 32px 0;
        position: relative;
        border-bottom: 1px solid #eee;
        margin-bottom: 32px;
        .tag {
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          height: 20px;
          background: #0cd56d;
          border-radius: 7px 0px 7px 0px;
          font-size: 12px;
          font-weight: 500;
          color: #fff;
          text-align: center;
          line-height: 20px;
        }
        .course_name {
          width: 296px;
          font-size: 18px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 26px;
          margin-bottom: 14px;
        }
        .title {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          width: 296px;
          margin-bottom: 12px;
        }
        .course_min_name {
          width: 315px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
          margin-bottom: 25px;
        }
        .course_bottom {
          img {
            float: left;
            width: 18px;
            height: 19px;
          }
          .time {
            float: left;
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            margin-left: 22px;
            line-height: 19px;
          }
          .alt {
            float: right;
            font-size: 14px;
            font-weight: 500;
            color: rgba(250, 52, 119, 1);
          }
        }
      }
    }
  }
  .main_r {
    float: right;
    width: 913px;
    .topNav {
      // height: 87px;
      height: 100px;
      width: 100%;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      margin-bottom: 32px;
      ul {
        display: flex;
        align-items: center;
        height: 100%;
        position: relative;
        li {
          font-size: 18px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          margin: 0 32px;
          cursor: pointer;
        }
        .expire_entrance {
          float: right;
          position: absolute;
          right: 32px;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }
    .topNavActive {
      position: relative;
      &:before {
        content: "";
        width: 72px;
        height: 6px;
        background: #0cd56d;
        position: absolute;
        bottom: -17px;
      }
    }
    .keep_class {
      cursor: pointer;
      padding: 24px 32px;
      background-color: #fff;
      span {
        float: left;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-right: 10px;
      }
      img {
        float: left;
        width: 23px;
        height: 23px;
      }
    }
    .class {
      background-color: #fff;
      border: 1px solid #eee;
      margin-bottom: 32px;
      .class_title {
        padding: 24px 0 20px 33px;
        border-bottom: 1px soli #eee;
        img {
          width: 32px;
          height: 32px;
          float: left;
        }
        span {
          float: left;
          margin-left: 16px;
          font-size: 20px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
        }
      }

      .class_list {
        .class_list_title {
          padding: 24px 0;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;

          span {
            display: block;
            float: left;
            text-align: center;
            &:last-of-type {
              float: right;
            }
          }
        }
        .class_list_tr {
          padding: 24px 0;
          border-bottom: 1px solid #eee;
          span {
            display: block;
            float: left;
            text-align: center;
            &:last-of-type {
              float: right;
            }
          }
        }
        .btn {
          width: 72px;
          height: 25px;
          background: #0cd56d;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          color: #fff;
          text-align: center;
          line-height: 25px;
          margin: auto;
          cursor: pointer;
        }
      }
    }
    .you_like {
      background-color: #fff;
      border-bottom: 1px solid #eee;
      .you_like_title {
        padding: 22px 32px;
        border-bottom: 1px solid #eee;
        font-size: 20px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 30px;
        span {
          float: left;
          display: block;
          width: 8px;
          height: 30px;
          background: #0cd56d;
          margin-right: 24px;
        }
      }
      .you_like_content {
        padding: 32px 40px;
        .you_like_item {
          cursor: pointer;
          width: 364px;
          height: 305px;
          background: rgba(255, 255, 255, 1);
          border-radius: 7px;
          border: 2px solid rgba(238, 238, 238, 1);
          padding: 21px 14px 0 14px;
          position: relative;
          float: left;
          margin-right: 32px;
          margin-bottom: 32px;
          &:nth-of-type(2n) {
            margin-right: 0;
          }
          .you_like_item_l {
            float: left;
            width: 220px;
            .name {
              height: 58px;
              font-size: 22px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              margin-bottom: 22px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .time {
              font-size: 14px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              span {
                margin-left: 10px;
                color: #fa6400;
              }
            }
          }
          .you_like_item_r {
            float: right;
            // background: url("../assets/bg.png") center center no-repeat;
            // background-size: cover;
            width: 111px;
            height: 123px;
            text-align: center;
            line-height: 123px;
            font-size: 38px;
            font-weight: 500;
            color: rgba(250, 100, 0, 1);
            img {
              width: 100%;
            }
          }
          .you_like_item_b {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            .teacher {
              padding: 0 14px 23px 14px;
              border-bottom: 2px solid #eee;
              .teacher_item {
                float: left;
                line-height: 37px;
                margin-right: 46px;
                &:last-of-type {
                  margin-right: 0;
                }
                img {
                  float: left;
                  width: 37px;
                  height: 37px;
                  border-radius: 50%;
                  margin-right: 11px;
                }
              }
            }
            .price {
              padding: 25px 14px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(153, 153, 153, 1);
              line-height: 40px;
              .over {
                float: left;
              }
              .after {
                float: left;
                margin-left: 66px;
              }
              .btn {
                float: right;
                width: 134px;
                height: 40px;
                background: #0cd56d;
                border-radius: 22px;
                font-size: 18px;
                font-weight: 500;
                color: #fff;
                text-align: center;
                line-height: 40px;
              }
            }
          }
        }
      }
    }
    .nullBox {
      width: 100%;
      height: 540px;
      text-align: center;
      img {
        width: 226px;
        margin-top: 90px;
      }
      p {
        margin-top: 20px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(191, 155, 159, 1);
      }
      button {
        margin-top: 30px;
        width: 416px;
        height: 76px;
        line-height: 76px;
        background: #0cd56d;
        border-radius: 38px;
        border: 0;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
      }
    }
  }
}
.adBox {
  width: 100%;
  height: 100px;
  font-size: 0;
  min-width: 1368px;
  position: fixed;
  bottom: 0;
  left: 0;
  a {
    display: block;
    width: 100%;
    height: 100%;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .closeBox {
      position: absolute;
      top: 25px;
      right: 60px;
      width: 58px;
      height: 58px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
}
.nextPlay{
  // width: 100%;
  height: 87px;
  background: #FADA1E;
  margin-top: 30px;
  display: flex;
  align-items: center;
  // position: relative;
  position: fixed;
  width: 1368px;
  left:calc(50% - 684px);
  bottom: 32px;
  border-radius: 15px;
  border: 1px solid black;
  .close{
    width: 26px;
    margin-right: 42px;
    margin-left: 20px;
  }
  .content{
    .title{
      font-size: 22px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      display: flex;
      align-items: center;
      img{
        width: 32px;
        margin-right: 12px;
      }
    }
    .more{
      padding-left: 44px;
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #333333;
      margin-top: 4px;
    }
  }
  button{
    position: absolute;
    right: 0;
    cursor: pointer;
    width: 148px;
    height: 42px;
    background: #526CFF;
    border-radius: 20px;
    margin-right: 57px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    border: 0;
    img{
      width: 22px;
      margin-right: 12px;
    }
  }
}
.recommend{
  width: 100%;
  background: white;
  .titleBox{
    height: 76px;
    line-height: 76px;
    padding-left: 64px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    position: relative;
    border-bottom: 1px solid #eeeeee;
    &::before{
      position: absolute;
      content: '';
      left:32px;
      top: 22px;
      width: 8px;
      height: 30px;
      background: #FADC1E;
    }
  }
  .content{
    padding: 28px 64px;
    white-space: nowrap;
    overflow-x: auto;
    .card{
      position: relative;
      display: inline-block;
      width: 381px;
      height: 250px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #DDDDDD;
      box-sizing: border-box;
      padding: 14px 22px;
      margin-right: 24px;
      padding-top: 30px;
      .title{
        font-size: 20px;
        font-family: MicrosoftYaHeiSemibold;
        color: #000000;
        padding-right: 76px;
        height: 60px;
        line-height: 30px;
        overflow: hidden;
        white-space: normal;
      }
      .iconBox{
        min-height: 54px;
        margin-top: 25px;
        overflow: hidden;
        .icon{
          width: 48px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          margin-right: 14px;
          float: left;
          img{
            width: 35px;
            height: 35px;
            border-radius: 50%;
          }
          span{
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            margin-top: 4px;
          }
        }
      }
      .bottomBox{
          margin-top: 27px;
          overflow: hidden;
          .price{
            font-size: 18px;
            font-weight: 500;
            color: #FF3356;
            margin-right: 24px;
            float:left;
          }
          .tip{
            font-size: 12px;
            font-weight: 500;
            color: #AAAAAA;
            float:left;
            position: relative;
            top: 5px;
          }
          button{
            cursor: pointer;
            float: right;
            width: 104px;
            height: 34px;
            background: #FE4C4B;
            border-radius: 17px;
            font-size: 14px;
            text-align: center;
            border: 0;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      
    }
  }

}

</style>
<style  lang="scss">
.el-table .cell {
  text-align: center;
}
.el-table thead {
  font-size: 14px;
  font-weight: 500 !important;
  color: rgba(51, 51, 51, 1) !important;
}
.main_mfd {
  .m-calendar
    .m-months-container
    .m-months-wrapper
    .m-months
    .m-row
    .m-day
    .m-select {
    background-color: #fadc1e !important;
    color: black !important;
  }
}
.main_kjc {
  .m-calendar
    .m-months-container
    .m-months-wrapper
    .m-months
    .m-row
    .m-day
    .m-select {
    background-color: #0cd56d !important;
    color: black !important;
  }
}
.m-calendar
  .m-months-container
  .m-months-wrapper
  .m-months
  .m-row
  .m-day
  .m-today {
  background: rgba(250, 220, 30, 0.3);
}
.m-calendar .m-toolbar .m-year-selector .m-next-btn,
.m-calendar .m-toolbar .m-year-selector .m-prev-btn {
  display: none;
}
.m-calendar .m-toolbar {
  justify-content: center !important;
  background-color: #fff !important;
  border-bottom: 1px solid #eee;
}
.m-calendar .m-toolbar .m-month-selector,
.m-calendar .m-toolbar .m-year-selector {
  width: auto !important;
  padding: 0 !important;
  position: relative;
}

.m-calendar .m-months-container .m-months-wrapper .m-months .m-row::before {
  background-color: #fff !important;
}
.m-calendar .m-week-header {
  background-color: #fff !important;
  padding-top: 40px;
}
.m-calendar .m-toolbar .m-month-selector .m-prev-btn {
  position: absolute;
  left: -95px;
  width: 8px !important;
  height: 13px !important;
  background-image: url("../assets/left.png") !important;
}
.m-calendar .m-toolbar .m-month-selector .m-next-btn {
  position: absolute;
  right: -30px;
  width: 8px !important;
  height: 13px !important;
  background-image: url("../assets/left.png") !important;
  transform: rotate(180deg);
}
.m-calendar .m-toolbar .m-month-selector {
  width: 37px !important;
}
</style>
